import { CsatEntity, CsatEvaluator, CsatSource } from 'constants/enums'
export interface CsatFormSend {
  rating: string | null | number
  comment: string
}

export enum CsatRequestSaveBodyAction {
  Rate = 'rate',
  Send = 'send',
  Exit = 'exit',
}

export interface CsatRequestSaveBody extends CsatFormSend {
  user_id: string
  company_id?: string
  action: CsatRequestSaveBodyAction
}

export interface SaveFormResponseCSAT {
  billId: string
}

export interface CSATPayload extends CsatFormSend {
  entity_id: string
  entity_type: CsatEntity
  evaluator_type: CsatEvaluator
  evaluator_id: string
  action: CsatRequestSaveBodyAction
  source: CsatSource | string
}
